import { render, staticRenderFns } from "./UserStatusSetting.vue?vue&type=template&id=77a894c3"
import script from "./UserStatusSetting.vue?vue&type=script&lang=js"
export * from "./UserStatusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports